import { render, staticRenderFns } from "./CheckCodeBox.vue?vue&type=template&id=25353a10"
import script from "./CheckCodeBox.vue?vue&type=script&lang=js"
export * from "./CheckCodeBox.vue?vue&type=script&lang=js"
import style0 from "./CheckCodeBox.vue?vue&type=style&index=0&id=25353a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports